const messages: Record<string, string> = {
  // ── App shell ────────────────────────────────────────────────────────────────
  'app.title': 'holisTICK',
  'app.nav.daily': 'День',
  'app.nav.statistics': 'Статистика',
  'app.nav.statsShort': 'Стат.',
  'app.nav.home': 'Перейти на сьогодні',
  'app.nav.habitStats': 'Статистика звичок',
  'app.nav.viewMenu': 'Змінити вигляд',
  'app.theme.switchToLight': 'Увімкнути світлу тему',
  'app.theme.switchToDark': 'Увімкнути темну тему',

  // ── Daily tracker ─────────────────────────────────────────────────────────────
  'daily.prevDay': 'Попередній день',
  'daily.nextDay': 'Наступний день',
  'daily.selectDate': 'Обрати дату',
  'daily.habits.title': 'Звички',
  'daily.habit.add': 'Додати звичку',
  'daily.habit.edit': 'Редагувати звичку',
  'daily.habit.select': 'Звичка',
  'daily.habits.empty': 'Побудуйте ритуали, що формують день. Додайте звичку, якої хочете дотримуватися.',
  'daily.habits.emptyExample': 'напр. «Випивати 8 склянок води» або «10 хвилин розтяжки».',
  'daily.habits.emptyShort': 'Додайте звичку',
  'daily.habits.count': '{completed}/{total}',
  'daily.habits.allDone': 'Усі звички виконано',
  'daily.habits.expand': 'Показати звички',
  'daily.habits.collapse': 'Сховати звички',
  'daily.notes.dailyTitle': 'Щоденна нотатка',
  'daily.notes.habitName': 'Щоденна нотатка',
  'daily.notes.edit': 'Редагувати щоденну нотатку',
  'daily.notes.placeholder': 'Швидке місце для думки, перемоги, хвилювання чи справи, яку не хочеться загубити.',
  'daily.notes.placeholderExample': 'напр. «Гарна розмова з Мією. Нагадати про пропозицію в п’ятницю».',
  'daily.notes.placeholderShort': 'Почніть писати',
  'daily.notes.limit': 'Досягнуто ліміт у {max} символів',
  'common.cancel': 'Скасувати',
  'common.save': 'Зберегти',
  'common.loading': 'Завантаження',

  // Tasks list
  'daily.tasks.title': 'Завдання',
  'daily.tasks.add': 'Додати завдання',
  'daily.tasks.quickAdd': 'Нове завдання',
  'daily.tasks.empty': 'Поки що порожньо. Добре. Коли з’явиться справа, додайте її сюди.',
  'daily.tasks.emptyExample': 'напр. «Зателефонувати стоматологу» або «Доробити презентацію на понеділок».',
  'daily.tasks.emptyShort': 'Додайте завдання',
  'daily.tasks.completed': '{count} виконано',
  'daily.tasks.count': '{completed}/{total}',
  'daily.tasks.allDone': 'Усі завдання виконано',
  'daily.tasks.expand': 'Показати завдання',
  'daily.tasks.collapse': 'Сховати завдання',
  'daily.tasks.recurringBadge': 'Повторюване',
  'daily.tasks.deleteTitle': 'Видалити',
  'daily.tasks.editTitle': 'Редагувати',
  'daily.tasks.deleteRepeatingTitle': 'Видалити повторюване завдання',
  'daily.tasks.deleteRepeatingBody': 'Це повторюване завдання. Що саме видалити?',
  'daily.tasks.deleteOccurrence': 'Це',
  'daily.tasks.deleteSeries': 'Усі',

  // Task modal
  'daily.todoModal.editTitle': 'Редагувати завдання',
  'daily.todoModal.newTitle': 'Нове завдання',
  'daily.todoModal.fieldTitle': 'Назва',
  'daily.todoModal.titlePlaceholder': 'Що потрібно зробити?',
  'daily.todoModal.fieldTime': 'Час',
  'daily.todoModal.repeat': 'Повтор',
  'daily.todoModal.recNone': 'Без повтору',
  'daily.todoModal.recDaily': 'Щодня',
  'daily.todoModal.recWeekly': 'Щотижня',
  'daily.todoModal.recBiweekly': 'Раз на два тижні',
  'daily.todoModal.recMonthly': 'Щомісяця',
  'daily.todoModal.recCustom': 'Довільно',
  'daily.todoModal.dayOfMonth': 'День місяця',
  'daily.todoModal.every': 'Кожні',
  'daily.todoModal.days': 'днів',
  'daily.todoModal.weeks': 'тижнів',
  'daily.todoModal.daySu': 'Нд',
  'daily.todoModal.dayMo': 'Пн',
  'daily.todoModal.dayTu': 'Вт',
  'daily.todoModal.dayWe': 'Ср',
  'daily.todoModal.dayTh': 'Чт',
  'daily.todoModal.dayFr': 'Пт',
  'daily.todoModal.daySa': 'Сб',
  'daily.todoModal.save': 'Зберегти',
  'daily.todoModal.create': 'Створити',
  'daily.todoModal.onComplete': 'Після завершення',
  'daily.todoModal.onCompleteArchive': 'Архівувати',
  'daily.todoModal.onCompleteDelete': 'Видалити',
  'daily.todoModal.requiredTitle': 'Перед збереженням введіть назву.',
  'daily.todoModal.timeConfirm': 'Встановити',

  // One-off task modal

  // Daily schedule
  'daily.cal.title': 'Розклад на день',

  // Progress
  'daily.progress.label': '{completed} з {total} виконано',
  'daily.progress.count': '{completed} з {total}',
  'daily.progress.fraction': '{completed}/{total}',

  'daily.focus.title': 'Фокус місяця',
  'daily.focus.edit': 'Редагувати фокус місяця',
  'daily.focus.placeholder': 'Про що має бути цей місяць? Оберіть одну тему, яка спрямує вибір.',
  'daily.focus.placeholderExample': 'напр. «Стати сильнішою» або «Випустити пет-проєкт».',
  'daily.focus.placeholderShort': 'Почніть писати',

  // Layout settings
  'daily.settings.title': 'Налаштування денної сторінки',
  'daily.settings.sections': 'Секції',
  'daily.settings.habits': 'Звички',
  'daily.settings.notes': 'Щоденна нотатка',
  'daily.settings.tasks': 'Завдання',
  'daily.settings.calendar': 'Розклад на день',
  'daily.settings.focus': 'Фокус місяця',
  'daily.settings.show': 'Показати',
  'daily.settings.hide': 'Сховати',
  'daily.datePicker.label': 'Вибір дати',
  'daily.datePicker.prevMonth': 'Попередній місяць',
  'daily.datePicker.nextMonth': 'Наступний місяць',
  'daily.datePicker.today': 'Сьогодні',
  'daily.datePicker.dayProgress': '{day}, {completed} з {total} виконано',
  'daily.cal.allDay': 'Весь день',
  'daily.cal.habitTag': 'Звичка',
  'daily.cal.taskTag': 'Завдання',
  'daily.cal.calTag': 'Кален.',
  'daily.cal.overdue': 'Прострочено',
  'daily.cal.connectBtn': 'Підключити Google Calendar',
  'daily.cal.disconnectBtn': 'Відʼєднати',
  'daily.cal.connectedBadge': 'Google Calendar',
  'daily.cal.addToGcal': 'Додати до Google Calendar',
  'daily.cal.removeFromGcal': 'Видалити з Google Calendar',

  // Recurrence badge labels
  'daily.rec.daily': 'Щодня',
  'daily.rec.weekly': 'Щотижня',
  'daily.rec.biweekly': 'Раз на два тижні',
  'daily.rec.monthly': 'Щомісяця',
  'daily.rec.intervalDays': 'Кожні {every} дн.',
  'daily.rec.intervalWeeks': 'Кожні {every} тиж.',

  // ── Monthly tracker ───────────────────────────────────────────────────────────

  // Add-habit form
  'monthly.addForm.namePlaceholder': 'Назва звички',
  'monthly.addForm.add': 'Додати',
  'monthly.addForm.temporary': 'Тимчасова звичка',
  'monthly.addForm.temporaryTooltip': 'Це тимчасовий трекер — він не показуватиметься в річній статистиці',

  // Column-edit popover
  'monthly.popover.editTitle': 'Редагувати звичку',
  'monthly.popover.name': 'Назва',
  'monthly.popover.colour': 'Колір',
  'monthly.popover.customColour': 'Свій колір',
  'monthly.popover.type': 'Тип',
  'monthly.popover.typeCheckbox': 'Прапорець',
  'monthly.popover.typeRating': 'Оцінка',
  'monthly.popover.typeText': 'Текст',
  'monthly.popover.calTime': 'Час у розкладі на день',
  'monthly.popover.clearTime': 'Очистити час',
  'habit.error.duplicateName': 'Звичка з такою назвою вже існує',
  'habit.error.saveFailed': 'Не вдалося зберегти. Спробуйте ще раз.',
  'notes.toolbar.bold': 'Жирний',
  'notes.toolbar.italic': 'Курсив',
  'notes.toolbar.highlight': 'Маркер',
  'notes.toolbar.bullets': 'Маркований список',
  'notes.toolbar.fontSmall': 'Менший текст',
  'notes.toolbar.fontNormal': 'Звичайний текст',
  'notes.toolbar.fontLarge': 'Більший текст',
  'monthly.popover.deleteHabit': 'Видалити звичку',
  'habit.delete.confirm': 'Видалити звичку «{name}»?',
  'habit.delete.confirmTitle': 'Видалити звичку',
  'habit.delete.confirmProgress': 'Увесь відстежений прогрес цієї звички буде видалено.',
  'habit.delete.confirmStats': 'Вона також зникне з річної статистики.',
  'habit.delete.confirmAction': 'Видалити',
  'habit.deleted': 'Звичку видалено',
  'habit.undo': 'Скасувати',
  'toast.habit.added': 'Нову звичку додано',
  'toast.habit.saveFailed': 'Помилка збереження звички',
  'toast.habit.deleted': 'Звичку видалено',
  'toast.task.added': 'Нове завдання додано',
  'toast.task.saveFailed': 'Помилка збереження завдання',
  'toast.note.saved': 'Нотатку збережено',
  'toast.note.saveFailed': 'Помилка збереження нотатки',
  'toast.focus.saved': 'Місячну ціль оновлено',
  'toast.focus.saveFailed': 'Помилка збереження місячної цілі',
  'monthly.popover.save': 'Зберегти',

  // ── Yearly tracker ────────────────────────────────────────────────────────────
  // Yearly tabs

  // ── Habits (yearly detail) ────────────────────────────────────────────────────
  'habits.selectAll': 'Обрати всі',
  'habits.deselectAll': 'Зняти вибір',
  'habits.noHabits': 'Немає звичок для відстеження.',
  'habits.selectPrompt': 'Оберіть одну чи кілька звичок, щоб побачити річну сітку.',
  'habits.done': 'Виконано',
  'habits.notDone': 'Не виконано',
  'habits.noRating': 'Немає оцінки',
  'habits.avg': 'Сер.',

  // ── Yearly tasks ────────────────────────────────────────────────────────────

  // ── Monthly read-only view ──────────────────────────────────────────────────
  'year.monthly.noHabits': 'Немає звичок для відстеження.',
  'year.monthly.previousMonth': 'Попередній місяць',
  'year.monthly.nextMonth': 'Наступний місяць',
  'year.monthly.dayColumn': 'День',

  // ── Tasks year view ─────────────────────────────────────────────────────────
  'year.tasks.noTasks': 'Немає виконаних завдань за цей рік',

  // ── Notes list view ─────────────────────────────────────────────────────────
  'year.notes.noNotes': 'Немає нотаток за цей місяць',
  'year.notes.dateColumn': 'Дата',
  'year.notes.noteColumn': 'Нотатка',

  // ── Stats navigation & headers ──────────────────────────────────────────────
  'app.nav.stats.habits': 'Звички',
  'app.nav.stats.tasks': 'Завдання',
  'app.nav.stats.notes': 'Нотатки',
  'stats.switch.yearly': 'Рік',
  'stats.switch.monthly': 'Місяць',
  'stats.habits.previousYear': 'Попередній рік',
  'stats.habits.nextYear': 'Наступний рік',
  'stats.tasks.previousYear': 'Попередній рік',
  'stats.tasks.nextYear': 'Наступний рік',
  'stats.notes.previousMonth': 'Попередній місяць',
  'stats.notes.nextMonth': 'Наступний місяць',
  'stats.export.csv': 'Експорт CSV',

  // ── Quick settings ─────────────────────────────────────────────────────────
  'settings.title': 'Швидкі налаштування',
  'settings.subtitle': 'Вигляд і мова',
  'settings.themeLabel': 'Тема',
  'settings.darkMode': 'Темна тема',
  'settings.lightMode': 'Світла тема',
  'settings.themeLight': 'Світла',
  'settings.themeDark': 'Темна',
  'settings.bgLabel': 'Колір тла',
  'settings.bgHint': 'Колір сторінки в усьому застосунку',
  'settings.reset': 'Скинути',
  'settings.langLabel': 'Мова',
  'settings.langHint': 'Оберіть мову інтерфейсу',
  'settings.layoutLabel': 'Макет',
  'settings.layoutHint': 'Змініть порядок секцій денної сторінки',
  'settings.layoutChange': 'Змінити макет',
  'settings.open': 'Відкрити налаштування',
  'settings.deleteAccount': 'Видалити акаунт',
  'settings.deleteAccount.confirmTitle': 'Видалити акаунт?',
  'settings.deleteAccount.confirmBody': 'Ваш акаунт і всі звички, прогрес, завдання та нотатки буде назавжди видалено через 30 днів. Якщо передумаєте, просто увійдіть до того часу.',
  'settings.deleteAccount.confirmAction': 'Видалити акаунт',
  'settings.deleteAccount.error': 'Не вдалося видалити акаунт. Перевірте з’єднання і спробуйте ще раз.',
  'account.pending.title': 'Ваш акаунт заплановано до видалення',
  'account.pending.body': 'Усе буде назавжди видалено {date}. Відновіть акаунт, щоб зберегти свої дані.',
  'account.pending.restore': 'Відновити акаунт',
  'account.pending.restoring': 'Відновлення…',
  'account.pending.error': 'Не вдалося відновити акаунт. Перевірте з’єднання і спробуйте ще раз.',
  'legal.privacy': 'Політика конфіденційності',
  'legal.terms': 'Умови використання',
  'legal.agreePrefix': 'Продовжуючи, ви погоджуєтеся з',
  'legal.and': 'та',
  'legal.back': 'Назад до Holistick',

  // ── Auth ───────────────────────────────────────────────────────────────────
  'auth.subtitle': 'Увійдіть, щоб відстежувати звички',
  'auth.languageQuestion': 'Оберіть мову',
  'auth.signInGoogle': 'Увійти через Google',
  'auth.signInApple': 'Увійти через Apple',
  'auth.signOut': 'Вийти',
  'auth.or': 'або',
  'auth.emailPlaceholder': 'you@email.com',
  'auth.sendMagicLink': 'Надіслати код для входу',
  'auth.sending': 'Надсилання…',
  'auth.magicLinkSent': 'Перевірте пошту — там буде код для входу. Вставте його нижче або натисніть посилання, якщо воно є в листі.',
  'auth.codePlaceholder': 'Код для входу',
  'auth.verifyCode': 'Увійти',
  'auth.verifying': 'Вхід…',
  'auth.changeEmail': 'Інша адреса',
  'auth.resendCode': 'Надіслати код ще раз',
  'auth.genericError': 'Щось пішло не так. Спробуйте ще раз.',

  // ── Onboarding ─────────────────────────────────────────────────────────────
  'onboarding.language.title': 'Оберіть мову',
  'onboarding.language.subtitle': 'Ви зможете змінити це пізніше в налаштуваннях',
  'onboarding.language.label': 'Мова',
  'onboarding.language.optionEnglish': 'English',
  'onboarding.language.optionUkrainian': 'Українська',
  'onboarding.common.next': 'Далі',
};

export default messages;
